import { makeFormatter } from 'afformative';

export const identityFormatter = makeFormatter<any, any>(value => value, {
	displayName: '@creditinfo-ui/formatters/identityFormatter',
});
